"use client";

import { useEffect, useRef } from 'react';
import { TelegramUserData } from '../config/api';

interface TelegramLoginWidgetProps {
  botName: string;
  onAuth: (userData: TelegramUserData) => void;
  onError: (error: string) => void;
}

export default function TelegramLoginWidget({ botName, onAuth, onError }: TelegramLoginWidgetProps) {
  const widgetRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Загружаем скрипт Telegram Login Widget
    const script = document.createElement('script');
    script.src = 'https://telegram.org/js/telegram-widget.js?22';
    script.setAttribute('data-telegram-login', botName);
    script.setAttribute('data-size', 'large');
    script.setAttribute('data-onauth', 'onTelegramAuth(user)');
    script.setAttribute('data-request-access', 'write');
    script.async = true;

    // Глобальная функция для обработки авторизации
    (window as Window & { onTelegramAuth?: (user: TelegramUserData) => void }).onTelegramAuth = (user: TelegramUserData) => {
      try {
        // Просто передаем данные пользователя в родительский компонент
        // API запрос будет выполнен в родительском компоненте
        onAuth(user);
      } catch (error) {
        console.error('Telegram auth error:', error);
        onError(error instanceof Error ? error.message : 'Ошибка авторизации через Telegram');
      }
    };

    if (widgetRef.current) {
      widgetRef.current.appendChild(script);
    }

    return () => {
      // Очистка при размонтировании
      const windowWithTelegram = window as Window & { onTelegramAuth?: (user: TelegramUserData) => void };
      if (windowWithTelegram.onTelegramAuth) {
        delete windowWithTelegram.onTelegramAuth;
      }
    };
  }, [botName, onAuth, onError]);

  return (
    <div className="flex flex-col items-center gap-4">
      <div ref={widgetRef} className="telegram-login-widget"></div>
      <p className="text-sm text-gray-500 dark:text-gray-400 text-center max-w-xs">
        Нажмите кнопку выше для входа через Telegram
      </p>
    </div>
  );
}
